module.exports = __webpack_public_path__ + "fonts/SuisseIntl-Bold.6a828d6.woff";